export default __webpack_public_path__ + "static/media/abc1new.dfa5ca88.webp";